/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
    const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
    optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
    if (this.hideSoldOutVariants) {
      optionValue.toggleAttribute("hidden", !available);
    } else {
      optionValue.classList.toggle("custom-sold-out", !available);
    }
  };

 document.addEventListener('variant:changed', function(event) {
    var selectedVariant = event.detail.variant; // Gives you access to the whole variant details
    var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    let productData = jsonData['product'];
    let prodoptionSelectors = Array.from(document.querySelectorAll(".ProductForm__Variants .ProductForm__Option--labelled"));
    if (prodoptionSelectors && prodoptionSelectors[0]){
      let option_one = Array.from(document.querySelectorAll("[data-opindex='0']")).map((optionSelector) => {
          return optionSelector.value;
      });
      option_one.forEach((value, valueIndex) => {
        const hasAtLeastOneCombination = productData["variants"].some((variant) =>variant["option1"] === value && variant), hasAvailableVariant = productData["variants"].some((variant) => variant["option1"] === value && variant["available"]);
        applyClassToSelector(prodoptionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
        if (prodoptionSelectors[1]) {
          let option_two = Array.from(document.querySelectorAll("[data-opindex='1']")).map((optionSelector) => {
              return optionSelector.value;
          });
          option_two.forEach((value2, valueIndex2) => {
            const hasAtLeastOneCombination2 = productData["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = productData["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
            applyClassToSelector(prodoptionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
            if (prodoptionSelectors[2]) {
            let option_three = Array.from(document.querySelectorAll("[data-opindex='1']")).map((optionSelector) => {
                  return optionSelector.value;
              });
              option_three.forEach((value3, valueIndex3) => {
                const hasAtLeastOneCombination3 = productData["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = productData["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
                applyClassToSelector(prodoptionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
              });
            }
          });
        }
      });
    }
 });
// for cart update manually
// document.addEventListener('product:added', function(event) {
//   var spancount = document.getElementsByClassName('Header__CartDot')[0].innerHTML;
//     var variant = event.detail.variant; // Get the variant that was added
//     var quantity = event.detail.quantity; // Get the quantity that was added
//   //alert(quantity);
 
// //alert(parseInt(quantity)+parseInt(spancount));
//   var newText = document.getElementsByClassName('Header__CartDot')[0];
// newText.innerHTML = parseInt(quantity)+parseInt(spancount);
//   });



  if(window.location.href == 'https://totdot.in/collections' || window.location.href == 'https://totdot.in/collections/') { 
        // indexOf will return the position of the first occurence of this string in the url
        // or -1 it it's not there.
        document.location.href = 'https://totdot.in';
    }
// $(document).ready(function(){
//   $(".ProductForm__AddToCart").click(function(){
//     alert("The paragraph was clicked.");
//   });
// });
// var elements = document.getElementsByClassName("swym-add-to-cart-btn");

// var myFunction = function() {
//     alert('attribute');
// };

// for (var i = 0; i < elements.length; i++) {
//     elements[i].addEventListener('click', myFunction, false);
// }
$(document).ready(function(){
  if(document.querySelector('.prodselector')){
     document.querySelector('.prodselector').dispatchEvent(new Event('change', {
            bubbles: true
    }));
  }
 
});